import { ExternalLink } from "lucide-react";
import type { Node, NodeProps } from "@xyflow/react";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle, RightSourceHandle } from "./shared";
import type { CustomerNodeData } from "./types";

type CustomerFlowNode = Node<CustomerNodeData, "customer">;

export function CustomerNode({ data }: NodeProps<CustomerFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <RightSourceHandle />
      <FlowNodeCard
        title="Customer"
        rightSlot={
          data.profileUrl ? (
            <a
              href={data.profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground transition-colors hover:text-foreground"
              aria-label="Open customer profile"
            >
              <ExternalLink className="size-3.5" />
            </a>
          ) : null
        }
      >
        <p className="text-sm font-semibold">{data.name || "Unknown customer"}</p>
        <FlowNodeRow label="Company" value={data.company || "-"} />
        <FlowNodeRow label="Email" value={data.email || "-"} />
      </FlowNodeCard>
    </>
  );
}
